import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { updateSelectedCharacteristicAction } from '../../../actions/instances/characteristics';
import CreateSelectModal from '../../Modals/CreateSelectModal/CreateSelectModal';
import CreateCharacteristicModal
  from '../../Modals/Content/Characteristics/CreateCharacteristicModal/CreateCharacteristicModal';
import SelectCharacteristicModal
  from '../../Modals/Content/Characteristics/SelectCharacteristicModal/SelectCharacteristicModal';
import './CharacteristicsCardList.scss';

const CharacteristicsCardList = ({
  characteristics,
  onItemAdded,
  isLoading,
  cityId,
  dynastyId,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [characteristicsInlineEditingShown, setCharacteristicsInlineEditingShown] = useState(false);
  const navigateToCharacteristic = (product) => {
    dispatch(updateSelectedCharacteristicAction(product));
    history.push('/instances/building-characteristics/view');
  };
  const itemSelected = (component) => {
    if (onItemAdded) {
      onItemAdded(component);
    }
    setCharacteristicsInlineEditingShown(false);
  };
  return (
    <>
      <CreateSelectModal
        title="Create or select a characteristic"
        createView={(
          <CreateCharacteristicModal
            onItemCreated={comp => itemSelected(comp)}
            cityId={cityId}
            dynastyId={dynastyId}
          />
        )}
        selectView={<SelectCharacteristicModal onItemSelected={comp => itemSelected(comp)} />}
        onRequestClose={() => setCharacteristicsInlineEditingShown(false)}
        isShown={characteristicsInlineEditingShown}
      />
      <section className="widget sidebar-list-widget mt-3">
        <h3 className="title">Characteristics</h3>
        <div className="list">
          {(characteristics && !isLoading) && characteristics.map(char => (
            <div className="item" onClick={() => navigateToCharacteristic(char)}>
              {char.images.length > 0 ? (
                <img alt={char.name} src={char.images[0].url} />
              ) : (
                <img alt={char.name} src="/images/default.jpg" />
              )}
              <button type="button">
                <strong>NAME: </strong>
                {char.name}
                <br />
                <strong>CODE: </strong>
                {char.code}
              </button>
            </div>
          ))}
          {(characteristics.length === 0 && !isLoading) && (
            <p>No characteristics were found for this building.</p>
          )}
          {isLoading && (
            <div className="row w-100">
              <div className="col-md-12 d-flex justify-content-center">
                <Spinner />
              </div>
            </div>
          )}
        </div>
        <div className="actions">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={() => setCharacteristicsInlineEditingShown(true)}>
            Link to Characteristic
          </a>
        </div>
      </section>
    </>
  );
};

CharacteristicsCardList.propTypes = {
  characteristics: PropTypes.array.isRequired,
  onItemAdded: PropTypes.func,
  isLoading: PropTypes.bool,
  cityId: PropTypes.number,
  dynastyId: PropTypes.number,
};

CharacteristicsCardList.defaultProps = {
  onItemAdded: undefined,
  isLoading: false,
  cityId: undefined,
  dynastyId: undefined,
};

export default CharacteristicsCardList;
